import { render, staticRenderFns } from "./Downloads.vue?vue&type=template&id=2d44fd44&scoped=true&"
import script from "./Downloads.vue?vue&type=script&lang=js&"
export * from "./Downloads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d44fd44",
  null
  
)

export default component.exports